import React, { Fragment } from "react";
import styled from "styled-components";
import I10n from "../../i10n";
import MsxIcons from "../../msx-icons";
import Button from "../../../atoms/button";
import ReactSelect from "react-select";
import { connect } from "react-redux";
import { updateConfigurationRedboxes, setPacPowerSupplyAutoSizeDisabled } from "../../configuration-management/ducks";
import { getCompatibleRedboxes } from "./ducks";
import { showNotificationWithButton } from "../../notification/ducks";
import { PRIMARY_COLOR } from "../../../color-constants";
import { SeTabbar } from '@se/web-ui-react';
import DisablePowerSupplyAutoSizingContent from "../../../components/disablePowerSupplyAutoSizingContent";

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

const DropdownContainer = styled.div`
  margin-bottom: 10px;
`;

const SectionTitle = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  margin: 10px 0px 10px 0px;
`;

const TabsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const NavigationTab = styled.nav`
  display: flex;
  width: 100%;
`;

const NavigationTabItem = styled.a`
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  flex: 1;
  text-align: center;
`;

const Container = styled.div`

  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  max-height: calc(100vh - 4em);
  overflow: hidden;
  position: relative;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  padding: 24px;
  ${props => props.$showBorder ? ` border-bottom: 2px solid #CCCCCC;` : ``}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const ModaleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background-color: #F4F4F4;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background-color: #F4F4F4;
  padding: 24px;
  overflow: auto;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
  background-color: #F4F4F4;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PAC_PARAMETERS_TABS = {
  REDBOXES: 0,
  POWER_SUPPLY: 1
}

class ModalManagePacParameters extends React.PureComponent {


  computeInitialTabValue = (configuration, showOnly) => {
    let result = PAC_PARAMETERS_TABS.REDBOXES;

    if (showOnly != null && Object.values(PAC_PARAMETERS_TABS).includes(showOnly)) {
      result = showOnly;
    }

    if (result === PAC_PARAMETERS_TABS.REDBOXES && !this.hasRedboxes(configuration)) {
      result = PAC_PARAMETERS_TABS.POWER_SUPPLY
    }

    return result;
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedRedbox: props.configuration.redboxes?.[0],
      candidateRedboxesLoading: false,
      candidateRedboxes: [],
      tabIndex: this.computeInitialTabValue(props.configuration, props.showOnly),
      tempSwitchStates: {}
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateStateIfMounted({ candidateRedboxesLoading: true });
    getCompatibleRedboxes(this.props.configuration).then((candidateRedboxes) => {
      this.updateStateIfMounted({ candidateRedboxes });
    })
    .catch(() => {
      this.props.showNotification(I10n.get('modal.manage_redboxes.error.compatible_retrieve'), 'error', () => null);
    })
    .finally(() => {
      this.updateStateIfMounted({ candidateRedboxesLoading: false });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  buildCandidateRedboxes = () => {
    const result = [];
    let actualRedboxMissing = true;

    this.state.candidateRedboxes.forEach((redbox) => {
      if (redbox.id === this.state.selectedRedbox?.id) {
        actualRedboxMissing = false;
      }
      result.push({
        redboxData: redbox,
        value: redbox.id,
        label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${redbox.connectivity}`, redbox.connectivity),
      });
    });
    if (actualRedboxMissing) {
      result.push({
        redboxData: this.state.selectedRedbox,
        value: this.state.selectedRedbox.id,
        label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${this.state.selectedRedbox.connectivity}`, this.state.selectedRedbox.connectivity),
      });
    }

    return result;
  }

  handleRedboxChange = (selectedOption) => {
    this.setState({ selectedRedbox: selectedOption.redboxData });
  };

  closeModal = () => {
    this.props.closeModal();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  hasRedboxes = (configuration) => {
    return  configuration.redboxes && configuration.redboxes.length > 0;
  }

  renderRedboxManagement = () => {
    const isDisabled = this.state.candidateRedboxesLoading || this.props.configurationSaver.isSaving;

    return (
      <>
        <SelectContainer>
          <DropdownContainer>
            <SectionTitle>{I10n.get("modal.manage_redboxes.connectivity")}</SectionTitle>
            <ReactSelect
              value={{
                redboxData: this.state.selectedRedbox,
                value: this.state.selectedRedbox.id,
                label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${this.state.selectedRedbox.connectivity}`, this.state.selectedRedbox.connectivity),
              }}
              name="redbox-connectivity"
              options={this.buildCandidateRedboxes()}
              onChange={this.handleRedboxChange}
              isDisabled={isDisabled}
              isSearchable={false}
              menuPlacement="bottom"
            />
          </DropdownContainer>
        </SelectContainer>
        <Footer>
          <ButtonContainer>
            <Button
              importance="emphasized"
              disabled={isDisabled}
              onClick={() => {
                this.props.updateConfigurationRedboxes(this.props.configuration, this.state.selectedRedbox.id).then(() => {
                  this.props.showNotification(I10n.get('modal.manage_redboxes.success.redbox_update'), 'success', () => null);
                  this.closeModal();
                }).catch(() => {
                  this.props.showNotification(I10n.get('modal.manage_redboxes.error.redbox_update'), 'error', () => null);
                });
              }}
            >
              {I10n.get('app.action.validate')}
            </Button>
          </ButtonContainer>
        </Footer>
      </>
    );
  }

  renderAutosizingPowerSuppliesManagement = () => {
    return (
      <Body> 
        <DisablePowerSupplyAutoSizingContent
          configuration={this.props.configuration}
          configurationSaver={this.props.configurationSaver}
          setPacPowerSupplyAutoSizeDisabled={this.props.setPacPowerSupplyAutoSizeDisabled}
          closeModal={this.props.closeModal}
        />
      </Body>
    );
  }

  computeTabComponents = (configuration) => {
    const result = [];
    const hasRedboxes = this.hasRedboxes(configuration);

    if (hasRedboxes && (this.props.showOnly == null || this.props.showOnly === PAC_PARAMETERS_TABS.REDBOXES)) {
      result.push(
        <NavigationTabItem
          className={this.state.tabIndex === PAC_PARAMETERS_TABS.REDBOXES ? 'active' : ''}
          onClick={() => this.setState({ tabIndex: PAC_PARAMETERS_TABS.REDBOXES })}
        >
          {I10n.get("screen.graphical_editor.modale.manage_pac_params.redundancy_switch")}
        </NavigationTabItem>
      );
    }

    if ((this.props.showOnly == null || this.props.showOnly === PAC_PARAMETERS_TABS.POWER_SUPPLY)) {
      result.push(
        <NavigationTabItem
          className={this.state.tabIndex === PAC_PARAMETERS_TABS.POWER_SUPPLY ? 'active' : ''}
          onClick={() => this.setState({ tabIndex: PAC_PARAMETERS_TABS.POWER_SUPPLY })}
        >
          {I10n.get("screen.graphical_editor.param_button.tooltip")}
        </NavigationTabItem>
      );
    }

    return result;
  }

  render() {
    const { configuration } = this.props;
    const tabComponents = this.computeTabComponents(configuration);
  
    return (
      <Container>
        <Header id="modal-manage-redboxes-header" $showBorder={tabComponents.length <= 1}>
          <TitleWrapper id="modal-manage-redboxes-titleWrapper">
            <Title id="modal-manage-redboxes-title">{I10n.get("screen.graphical_editor.modal.manage_pac_params")}</Title>
            <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
            </CloseIcon>
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <ModaleWrapper id="modal-manage-redboxes-body">
          {tabComponents.length > 1 && (
              <SeTabbar id="modal-manage-redboxes-seTabbar" color="alternative" option="content" overflow="scroll">
                <TabsContainer>
                  <NavigationTab>
                    {tabComponents.map((tabComponent, idx) => {
                      return (
                        <Fragment key={idx}>
                          {tabComponent}
                        </Fragment>
                      );
                    })}
                  </NavigationTab>
                </TabsContainer>
              </SeTabbar>
          )}
          {this.state.tabIndex === PAC_PARAMETERS_TABS.REDBOXES ? this.renderRedboxManagement() : this.renderAutosizingPowerSuppliesManagement()}
        </ModaleWrapper>
      </Container>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    configuration: state.configuration,
    configurationSaver: state.configurationSaver,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfigurationRedboxes: (configuration, redboxId) => dispatch(updateConfigurationRedboxes(configuration, redboxId)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement, 10000)),
    setPacPowerSupplyAutoSizeDisabled: (remoteAreaIdx, localRackIdx, newStatus) =>
      dispatch(setPacPowerSupplyAutoSizeDisabled(remoteAreaIdx, localRackIdx, newStatus))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalManagePacParameters);